import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bc2afe2c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "date-picker-selector"
};
const _hoisted_2 = {
  class: "text-content"
};
const _hoisted_3 = {
  class: "period"
};
const _hoisted_4 = {
  class: "range"
};
const _hoisted_5 = {
  class: "period dates"
};
const _hoisted_6 = {
  class: "range"
};
const _hoisted_7 = {
  class: "compare"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_calendar_icon = _resolveComponent("calendar-icon");
  const _component_loading_element = _resolveComponent("loading-element");
  return _openBlock(), _createBlock(_component_loading_element, {
    loading: $props.loading,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event)),
    size: $props.size
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($props.selector?.title), 1), _withDirectives(_createElementVNode("span", {
      class: "compare"
    }, _toDisplayString($props.selector?.compareTitle), 513), [[_vShow, !$options.turnOffCompare]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString($options.formattedRange), 1), _createElementVNode("span", _hoisted_7, _toDisplayString($options.formattedCompare), 1)])]), _createVNode(_component_calendar_icon)])]),
    _: 1
  }, 8, ["loading", "size"]);
}